import localForage from "localforage";

const PREFIX = "v2:";

function isLandingPathname(pathname) {
	const normalized = pathname.replace(/\/$/, "") || "/";

	if (normalized === "/" || normalized === "/index.html") {
		return true;
	}

	return false;
}

function hasLegacyLocalStorage() {
	try {
		for (let i = 0; i < localStorage.length; i++) {
			const key = localStorage.key(i);

			if (key !== null && key.indexOf(PREFIX) === 0) {
				return true;
			}
		}
	} catch (error) {
		return false;
	}

	return false;
}

function hasPersistedTripKeys(keys) {
	for (let i = 0; i < keys.length; i++) {
		if (keys[i].indexOf(PREFIX) === 0) {
			return true;
		}
	}

	return false;
}

function redirectToTrip() {
	const suffix = globalThis.location.search + globalThis.location.hash;

	globalThis.location.replace("/trip" + suffix);
}

function clearTripRedirectPending() {
	document.documentElement.classList.remove("trip-redirect-pending");
}

if (isLandingPathname(globalThis.location.pathname) === false) {
	clearTripRedirectPending();
} else if (hasLegacyLocalStorage() === true) {
	redirectToTrip();
} else {
	document.documentElement.classList.add("trip-redirect-pending");

	localForage
		.keys()
		.then(function onKeys(keys) {
			if (hasPersistedTripKeys(keys) === true) {
				redirectToTrip();
			}
		})
		.catch(function onTripRedirectError() {})
		.finally(function onTripRedirectDone() {
			clearTripRedirectPending();
		});
}
